<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm12 v-if="responseError">
              <span class="red--text">{{ responseError }}</span>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field name="code" label="Code" type="text" v-model="queryParams.code"></v-text-field>
            </v-flex>
            <v-flex sm4 v-if="!user.shopId">
              <ShopMultiSelect
                :ids="queryParams.shopIds"
                @set="setShop"
              />
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="manufacturingAccountList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.code }}</td>
                    <td>{{ props.item.shop.code }}</td>
                    <td>{{ props.item.year }}</td>
                    <td>{{ props.item.month }}</td>
                    <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
                    <td>{{ props.item.createdBy }}</td>
                    <td>
                      <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn flat icon color="blue lighten-2" @click="print(props.item.id)">
                        <v-icon>print</v-icon>
                      </v-btn>
                      <v-btn flat icon color="blue lighten-2" @click="exportIncomeStatement(props.item.id)">
                        <v-icon>description</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ShopMultiSelect from "../templates/ShopMultiSelect.vue";
import { manufacturingAccountService } from "../../services/manufacturing-account-service";
import { ManufacturingAccount } from "../../models/model";
import { commonService } from "../../services/common-service";
export default {
  name: "ManufacturingAccountList",
  components: { ShopMultiSelect },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Maufacturing Account",
        disabled: true,
      },
    ],
    headers: [
      { text: "Manufcaturing Account Code", align: "left", value: "code" },
      { text: "Shop Code", value: "shopCode" },
      { text: "Year", value: "year" },
      { text: "Month", value: "month" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
      { text: "Action", value: "name", align: "left", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    decimalFormat: "",
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    manufacturingAccountList: [],
    totalRows: 0,

    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      code: "",
      shopIds: [],
    },
    manufacturingAccount: new ManufacturingAccount(),
    responseError: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getManufacturingAccountList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.shopIds) {
      this.queryParams.shopIds = this.$route.query.shopIds.map((d) => +d);
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if(this.user.shop){
      this.setShop([this.user.shop]);
    }
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      if (this.queryParams.shopIds.length == 0) {
        this.responseError = "Please select shop";
      } else {
        this.responseError = "";
        this.queryParams.page = this.pagination.page;
        this.queryParams.size = this.pagination.rowsPerPage;
        this.$router.replace({
          name: "manufacturing-accounts",
          query: this.queryParams,
        });
        this.getManufacturingAccountList();
      }
    },
    setShop(selectedShopList) {
      this.queryParams.shopIds = selectedShopList.map((s) => s.id);
    },
    getManufacturingAccountList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      manufacturingAccountService
        .getManufacturingAccountList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.manufacturingAccountList = res.data.manufacturingAccountList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onEdit(manufacturingAccount) {
      // go to details page
      this.$router.push("/manufacturing-account/" + manufacturingAccount.id);
    },
    print(id) {
      manufacturingAccountService
        .getManufacturingAccountById(id)
        .then((res) => {
          this.manufacturingAccount = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printInvoice("incomestatementPrint");
        });
    },
    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
    exportIncomeStatement(id) {
      manufacturingAccountService
        .exportManufacturingAccount(id)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
